import React, { useEffect, useState } from "react";
import styles from "./schedule.module.css";
import StarContainer from "../../components/star-container/star-container";
import Header from "../../components/header/header";
import { useDispatch, useSelector } from "react-redux";
import ScrollUpButton from "../../components/buttons/scroll-up-button/scroll-up-button";
import Footer from "../../components/footer/footer";
import { v4 } from "uuid";
import Hurdle from "../../components/schedule/hurdle";
import EventDescriptionModal from "../../components/schedule/modal/event-description-modal";
import { selectHurdleNames, selectSchedulesEntities } from "../../store/selectors/scheduleSelectors";
import { getUIText } from "../../translation";

export default function Schedule() {
    const theme = useSelector((state) => state.theme.value);
    const lang = useSelector((state) => state.lang.value);
    // const schedules = useSelector((state) => state.schedules.value);

    const hurdleNames = useSelector((state) => selectHurdleNames(state));
    const scheduleEntities = useSelector((state) => selectSchedulesEntities(state));

    const [selected, setSelected] = useState(null);

    return (
        <div id="container" data-theme={theme} data-lang={lang}>
            {theme === "dark" && <StarContainer />}
            <Header title={getUIText(lang, "header.title.schedule")} />

            <div className={styles["schedule-container"]}>
                {hurdleNames.map((hurdleName) => {
                    const schedules = scheduleEntities[hurdleName];

                    return <Hurdle lang={lang} schedules={schedules} setSelected={setSelected} key={v4()} />;
                })}
            </div>

            <EventDescriptionModal lang={lang} selected={selected} setSelected={setSelected} />

            <ScrollUpButton />
            <Footer />
        </div>
    );
}
